@if (prototypeMenu) {
  <app-context-menu-item title="New file" icon="sapphire-plus" size="l">
    <app-file-quick-form
      class="quick-form"
      [file]="stitchItem"
      [tenantItems]="[{ accountId: tenantId }]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
    />
  </app-context-menu-item>
  <app-context-menu-item title="New folder" icon="sapphire-folders" size="l">
    <app-folder-quick-form
      class="quick-form"
      [folder]="containerStitchItem"
      [tenantItems]="[{ accountId: tenantId }]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
    (more)="handleQuickDetails($event)" />
  </app-context-menu-item>
  @if (sidebarFilterKey === 'flagged') {
    <app-context-menu-item title="Unflag all" icon="sapphire-flagged" size="l" [close]="true" (execute)="unFlagAll()" />
  }
  <!-- Pavel 2026-11-04: View settings are for team rails (My Workspace, Team Workspace) only for now. -->
  @if (offersViewSettings) {
    <app-context-menu-divider />
    <app-context-menu-item
      title="View settings…"
      icon="sapphire-filters"
      size="l"
      [close]="true"
      (execute)="openRowViewSettings()"
    />
  }
} @else {
@if (sidebarFilterKey === 'following') {
  <app-context-menu-item title="Clear my subscriptions" [close]="true" (execute)="clearMySubscriptions()" />
}
@if ((isTeamRail && sidebarFilterKey === 'all_folders') || !(['all_folders', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="Add new file" icon="sapphire-plus"
    >
    <app-file-quick-form
      class="quick-form"
      [file]="stitchItem"
        [tenantItems]="[{ accountId: tenantId }]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
      />
    </app-context-menu-item>
  }

  @if ((isTeamRail && sidebarFilterKey === 'all_files') || !(['all_files', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="Add new folder" icon="sapphire-plus"
      >
      <app-folder-quick-form
        class="quick-form"
        [folder]="containerStitchItem"
        [tenantItems]="[{ accountId: tenantId }]"
        [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
        (close)="handleClose()"
        (more)="handleQuickDetails($event)" />
      </app-context-menu-item>
    }

    @if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey) && (endsWithSettings || (['flagged', 'snoozed', 'followed'] | includesBy: sidebarFilterKey))) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all" icon="sapphire-flagged"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()" icon="sapphire-follow-up"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all" icon="sapphire-snooze"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if (endsWithSettings && (['flagged', 'snoozed', 'followed'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all" icon="sapphire-trash"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <app-context-menu-item
        title="Empty trash" icon="sapphire-trash"
        [disabled]="!(tenantId | appCanPurgeTeamItem)"
        [note]="PURGE_REFUSED_REASON"
        [matTooltip]="(tenantId | appCanPurgeTeamItem) ? '' : PURGE_REFUSED_REASON"
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (insideTeam) {
      @if (['deleted', 'archived'] | includesBy: sidebarFilterKey) {
        <app-context-menu-divider />
      }
      <app-context-menu-item title="View settings…" icon="sapphire-settings" [close]="true" (execute)="openRowViewSettings()" />
    } @else if (endsWithSettings) {
      <!-- Pavel 2026-11-04: Files settings are for teams only for now; no "Settings" on a personal login's rail. -->
      <app-context-menu-item
        title="Settings" icon="sapphire-settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }

}
